<template lang="pug">
  .riders__preloader
    img(src="@/assets/img/global/loader.gif" alt="")
</template>

<script>
export default {
  name: 'RidersPreloader'
}
</script>
